<template>
  <input :data-value="valueFormatted"
         type="date" class="pickadate"
         @keydown="keyDown"
         @click="openPicker">
</template>

<script>
/* eslint-disable no-undef */
import 'bower/pickadate/lib/compressed/picker.date'
import { formatDisplayDate } from '../../utils/date'
import {getFocusables} from '../../utils/focusable'

export default {
  props: {
    value: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  data: function () {
    return {
      picker: null,
      manuallyFocusedElement: null
    }
  },
  computed: {
    valueFormatted: function () {
      return formatDisplayDate(this.value)
    }
  },
  watch: {
    value: function (value) {
      if (this.picker) this.picker.set('select', value)
    },
    minDate: function (value) {
      if (value && this.picker) this.picker.set('min', value)
    },
    maxDate: function (value) {
      if (value && this.picker) this.picker.set('max', value)
    }
  },
  mounted () {
    const self = this
    function handleFocus (root) {
      self.handleFocus(root)
    }
    this.picker = jQuery(this.$el).pickadate(
      {
        klass: {
          picker: 'picker picker--date',
          frame: 'picker__frame date-frame'
        },
        monthsFull: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        monthsShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        weekdaysFull: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        today: this.$t('generic.today'),
        close: this.$t('generic.cancel'),
        labelMonthNext: this.$t('generic.next-month'),
        labelMonthPrev: this.$t('generic.prev-month'),
        clear: false,
        firstDay: 0,
        editable: true,
        format: 'ddd d mmm yyyy',
        formatSubmit: 'dd-mm-yyyy',
        hiddenName: false,
        closeOnClear: true,
        selected: 'picker__day--selected',
        focused: 'picker--focused',
        now: 'picker__day--today',
        highlighted: 'picker__day--highlighted',
        infocus: 'picker__day--infocus',
        outfocus: 'picker__day--outfocus',
        container: 'body',
        onOpen: function () {
          handleFocus(this.$root[0])

          $('.picker__day').attr('tabindex', 0)
          $('.picker__nav--next').attr('tabindex', 0)
          $('.picker__nav--prev').attr('tabindex', 0)
          setTimeout(
            // delay focus shift to the next frame, because it's wrongly switched to the input field
            // later this frame for some reason
            function () {
              // put focus inside the popup; today by default, and the selected date if there is one
              $('.picker__day--today').focus()
              $('.picker__day--selected').focus()
            },
            1
          )
        },
        onSet: (context) => {
          if ('select' in context) {
            this.onDateSelected(context.select)
          }
        }
      }
    ).pickadate('picker')
  },
  beforeDestroy () {
    this.picker.stop()
  },
  methods: {
    onDateSelected: function (value) {
      if (value) {
        this.$emit('input', new Date(value))
      }
    },
    openPicker: function () {
      if (this.picker) {
        this.picker.open()
      }
    },
    keyDown: function (e) {
      if ((e.keyCode || e.which) === 32 || (e.keyCode || e.which) === 13) {
        this.openPicker()
      }
      if ((e.keyCode || e.which) !== 9) {
        e.preventDefault()
      }
    },
    handleFocus: function (root) {
      this.$nextTick(function () {
        const focusables = getFocusables(root)
        if (focusables.length > 0) {
          focusables[0].focus()
        }
        const component = this
        for (const focusable of focusables) {
          focusable.addEventListener('focus', function () {
            component.manuallyFocusedElement = focusable
          })
        }
        root.addEventListener('keydown', (event) => {
          const isTab = event.which === 9 && !event.shiftKey
          const isShiftTab = event.which === 9 && event.shiftKey
          if (isTab || isShiftTab) {
            const firstFocusable = focusables[0]
            const lastFocusable = focusables[focusables.length - 1]

            if (isShiftTab && event.target === firstFocusable) {
              lastFocusable.focus()
              event.preventDefault()
            }
            if (isTab && event.target === lastFocusable) {
              firstFocusable.focus()
              event.preventDefault()
            }
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/components/DatePicker.vue